import styled, { css } from 'styled-components'

export const TtsDeleteButtonWrapper = styled.div<{
  $isDisabled: boolean
}>`
  padding: 2px;
  border-radius: 4px;
  background: none;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled
      ? css`
          display: none;
          pointer-events: none;
        `
      : css`
          &:hover {
            display: block;
          }
        `}
`
